/**
 * Global ref-counted loading overlay for session and async actions.
 */
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import LoadingOverlay from "../components/ui/LoadingOverlay";

const LoadingOverlayContext = createContext({
  showLoading: () => {},
  hideLoading: () => {},
});

export function LoadingOverlayProvider({ children }) {
  const [depth, setDepth] = useState(0);
  const [message, setMessage] = useState("");

  const showLoading = useCallback((nextMessage = "") => {
    setMessage((prev) => nextMessage || prev || "Loading…");
    setDepth((d) => d + 1);
  }, []);

  const hideLoading = useCallback(() => {
    setDepth((d) => Math.max(0, d - 1));
  }, []);

  const value = useMemo(
    () => ({ showLoading, hideLoading }),
    [showLoading, hideLoading]
  );

  return (
    <LoadingOverlayContext.Provider value={value}>
      {children}
      <LoadingOverlay
        open={depth > 0}
        message={message}
        ariaLabel={message || "Loading"}
      />
    </LoadingOverlayContext.Provider>
  );
}

export function useLoadingOverlay() {
  return useContext(LoadingOverlayContext);
}
